module.exports = __webpack_public_path__ + "static/media/Carioca-Anime-01.722e42e4.jpg";